import { Mixins as CoreMixins } from '@yanolja-rnd/ya-com-core';

export const Mixins = {
  ...CoreMixins,
};
